import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './LoadingScreen.scss'

const LoadingScreen = ({ type }) => {
    let className = styles.base
    if (type) className += ` ${styles[`base__${type}`]}`
    return (
        <div className={className}>
            <div className={styles.spinner}>
                <div className={styles.caption}>
                    <FormattedMessage
                        id='loading_screen.caption'
                        description='Текст над спиннером на экране загрузки'
                        defaultMessage='Загрузка содержимого...'
                    />
                </div>
            </div>
        </div>
    )
}

LoadingScreen.propTypes = {
    type: PropTypes.oneOf(['gamefield', 'fullscreen', 'window']),
}

export default LoadingScreen



// WEBPACK FOOTER //
// ./components/LoadingScreen/LoadingScreen.jsx